import { render, staticRenderFns } from "./ManifestShowSkeleton.vue?vue&type=template&id=4ed2bec2&scoped=true&"
import script from "./ManifestShowSkeleton.vue?vue&type=script&lang=js&"
export * from "./ManifestShowSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ManifestShowSkeleton.vue?vue&type=style&index=0&id=4ed2bec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2bec2",
  null
  
)

export default component.exports